import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedUserId: null,
};

const persistWhitelist = ['selectedUserId'];

const memberDetailsSlice = createSlice({
  name: 'memberDetails',
  initialState,
  reducers: {
    currentUserIdSelected: (state, action) => {
      const { userId } = action.payload;
      state.selectedUserId = userId;
    },
  },
});

export { persistWhitelist as membersDetailsPersistWhitelist };
export const { currentUserIdSelected } = memberDetailsSlice.actions;

export default memberDetailsSlice.reducer;
